export const Features = {
    // Navigation
    NAV: {
        HOME: {
            pt: "HOME",
            en: "HOME"
        },
        ABOUT: {
            pt: "SOBRE NÓS",
            en: "ABOUT US"
        },
        TIPS: {
            pt: "DICAS",
            en: "TIPS"
        },
        SERVICES: {
            pt: "SERVIÇOS",
            en: "SERVICES"
        },
        CONTACT: {
            pt: "CONTACTOS",
            en: "CONTACT"
        }
    },

    // Banner
    BANNER: {
        WELCOME: {
            pt: "Bem-vindo à\n FielCarga",
            en: "Welcome to\n FielCarga"
        },
        CALL_NOW: {
            pt: "LIGUE JÁ",
            en: "CALL NOW"
        },
        CALL_NOW_FULL: {
            pt: "LIGUE JÁ (+351) 914 440 333",
            en: "CALL NOW (+351) 914 440 333"
        },
        REQUEST_QUOTE: {
            pt: "SOLICITE O SEU ORÇAMENTO",
            en: "REQUEST YOUR QUOTE"
        },
        QUOTE_DESCRIPTION: {
            pt: "Descreva o serviço pretendido.",
            en: "Describe the service you need."
        }
    },

    // Form
    FORM: {
        FULL_NAME: {
            pt: "Nome/Apelido",
            en: "Full Name"
        },
        EMAIL: {
            pt: "Email",
            en: "Email"
        },
        PHONE: {
            pt: "Telefone",
            en: "Phone"
        },
        PROPERTY_TYPE: {
            pt: "Tipo",
            en: "Type"
        },
        SELECT_PROPERTY: {
            pt: "Selecione...",
            en: "Select..."
        },
        APARTMENT: {
            pt: "Apartamento",
            en: "Apartment"
        },
        HOUSE: {
            pt: "Moradia",
            en: "House"
        },
        GARAGE: {
            pt: "Garagem",
            en: "Garage"
        },
        COMPANY: {
            pt: "Empresa",
            en: "Company"
        },
        TIPOLOGIA: {
            pt: "Tipologia",
            en: "Typology"
        },
        TIPOLOGIA_PLACEHOLDER: {
            pt: "Ex: T2, T3, T4, etc.",
            en: "Ex: T2, T3, T4, etc."
        },
        ELEVATOR: {
            pt: "Elevador",
            en: "Elevator"
        },
        WITH_ELEVATOR: {
            pt: "Com elevador",
            en: "With elevator"
        },
        WITHOUT_ELEVATOR: {
            pt: "Sem elevador",
            en: "Without elevator"
        },
        SELECT_ELEVATOR: {
            pt: "Selecione...",
            en: "Select..."
        },
        PICKUP_POSTAL_CODE: {
            pt: "Código Postal de Recolha",
            en: "Pickup Postal Code"
        },
        PICKUP_LOCATION: {
            pt: "Localidade de Recolha",
            en: "Pickup Location"
        },
        DELIVERY_POSTAL_CODE: {
            pt: "Código Postal de Entrega",
            en: "Delivery Postal Code"
        },
        DELIVERY_LOCATION: {
            pt: "Localidade de Entrega",
            en: "Delivery Location"
        },
        PICKUP: {
            pt: "Recolha: código postal e localidade",
            en: "Pickup: postal code and location"
        },
        DELIVERY: {
            pt: "Entrega: código postal e localidade",
            en: "Delivery: postal code and location"
        },
        SUBJECT: {
            pt: "Assunto",
            en: "Subject"
        },
        MESSAGE: {
            pt: "Mensagem",
            en: "Message"
        },
        MESSAGE_HELPER: {
            pt: "Tipologia, descrição de móveis, pode utilizar WhatsApp para fotos do que vai mudar.",
            en: "Type, description of furniture, you can use WhatsApp for photos of what you want to move."
        },
        NEXT: {
            pt: "Próximo",
            en: "Next"
        },
        BACK: {
            pt: "Voltar",
            en: "Back"
        },
        SEND: {
            pt: "Enviar mensagem",
            en: "Send message"
        },
        SENDING: {
            pt: "A enviar...",
            en: "Sending..."
        },
        STEP: {
            pt: "Passo",
            en: "Step"
        },
        OF: {
            pt: "de",
            en: "of"
        },
        PRIVACY_CHECKBOX: {
            pt: "Aceito a",
            en: "I accept the"
        },
        PRIVACY_POLICY: {
            pt: "Política de Privacidade",
            en: "Privacy Policy"
        },
        AND: {
            pt: "e os",
            en: "and the"
        },
        TERMS_CONDITIONS: {
            pt: "Termos e Condições",
            en: "Terms and Conditions"
        },
        VALIDATION_NAME: {
            pt: "Por favor, preencha o nome completo.",
            en: "Please fill in your full name."
        },
        VALIDATION_EMAIL: {
            pt: "Por favor, preencha um email válido.",
            en: "Please fill in a valid email."
        },
        VALIDATION_PHONE: {
            pt: "Por favor, preencha o telefone.",
            en: "Please fill in your phone number."
        },
        VALIDATION_PROPERTY: {
            pt: "Por favor, selecione Apartamento ou Moradia.",
            en: "Please select Apartment or House."
        },
        VALIDATION_PRIVACY: {
            pt: "Por favor, aceite os termos e condições e a política de privacidade.",
            en: "Please accept the terms and conditions and privacy policy."
        },
        VALIDATION_POSTAL_CODE: {
            pt: "Por favor, insira um código postal válido no formato XXXX-XXX.",
            en: "Please enter a valid postal code in the format XXXX-XXX."
        },
        SUCCESS_MESSAGE: {
            pt: "A sua mensagem foi enviada com sucesso.",
            en: "Your message has been sent successfully."
        }
    },

    // Services
    SERVICES: {
        SECTION_SUBTITLE: {
            pt: "O nosso compromisso é consigo!",
            en: "Our commitment is with you!"
        },
        SECTION_TITLE: {
            pt: "Serviço realizado por equipa\n profissional e responsável!",
            en: "Service performed by professional\n and responsible team!"
        },
        SERVICE_1_TITLE: {
            pt: "EQUIPAS DE MUDANÇAS E TRANSPORTES",
            en: "MOVING AND TRANSPORT TEAMS"
        },
        SERVICE_1_DESC: {
            pt: "A FielCarga conta com uma equipa especializada para realizar a sua mudança com rapidez, segurança e profissionalismo. O orçamento é ajustado consoante os serviços necessários e pode ser solicitado diretamente através do formulário do nosso site ou pelo WhatsApp, de forma rápida e prática!",
            en: "FielCarga has a specialized team to carry out your move with speed, safety and professionalism. The quote is adjusted according to the necessary services and can be requested directly through our website form or via WhatsApp, quickly and easily!"
        },
        SERVICE_2_TITLE: {
            pt: "ARMAZENAGEM | Boxes",
            en: "STORAGE | Boxes"
        },
        SERVICE_2_DESC: {
            pt: "Disponibilizamos o veículo adequado à mercadoria, equipa em número ideal, embalamento, montagem e desmontagem, além da organização completa no destino.",
            en: "We provide the appropriate vehicle for the goods, ideal number of team members, packaging, assembly and disassembly, in addition to complete organization at the destination."
        },
        SERVICE_3_TITLE: {
            pt: "DE NORTE A SUL",
            en: "FROM NORTH TO SOUTH"
        },
        SERVICE_3_DESC: {
            pt: "Após a entrega, recolhemos todo o material de embalamento para reciclagem, porque levamos a consciência ambiental a sério! Entre em contacto connosco e peça já o seu orçamento personalizado!",
            en: "After delivery, we collect all packaging material for recycling, because we take environmental awareness seriously! Contact us and request your personalized quote now!"
        },
        READ_MORE: {
            pt: "Ver mais",
            en: "Read more"
        },
        READ_LESS: {
            pt: "Ler menos",
            en: "Read less"
        }
    },

    // CTA
    CTA: {
        SUBTITLE: {
            pt: "O nosso compromisso é consigo!",
            en: "Our commitment is with you!"
        },
        TITLE: {
            pt: "Precisa de um transporte seguro e profissional?",
            en: "Need safe and professional transport?"
        },
        BUTTON: {
            pt: "Contacte-nos",
            en: "Contact Us"
        }
    },

    // Footer
    FOOTER: {
        COMMITMENT: {
            pt: "O nosso compromisso é consigo!",
            en: "Our commitment is with you!"
        },
        LICENSE: {
            pt: "Alvará nº 669921",
            en: "License nº 669921"
        },
        SERVICES_TITLE: {
            pt: "SERVIÇOS",
            en: "SERVICES"
        },
        MENU_TITLE: {
            pt: "MENU",
            en: "MENU"
        },
        CONTACTS_TITLE: {
            pt: "CONTACTOS",
            en: "CONTACTS"
        },
        COPYRIGHT: {
            pt: "© 2025 MYOUWEB - Marketing Digital. Todos os direitos reservados",
            en: "© 2025 MYOUWEB - Digital Marketing. All rights reserved"
        },
        REQUEST_QUOTE: {
            pt: "PEÇA JÁ O SEU ORÇAMENTO",
            en: "REQUEST YOUR QUOTE NOW"
        },
        SERVICE_TRANSPORTES: {
            pt: "Transportes",
            en: "Transport"
        },
        SERVICE_MUDANCAS_PARTICULARES: {
            pt: "Mudanças Particulares",
            en: "Residential Moves"
        },
        SERVICE_MUDANCAS_EMPRESARIAIS: {
            pt: "Mudanças Empresariais",
            en: "Business Moves"
        },
        SERVICE_TRANSPORTES_NACIONAIS: {
            pt: "Transportes Nacionais",
            en: "National Transport"
        },
        SERVICE_TRANSPORTES_INTERNACIONAIS: {
            pt: "Transportes Internacionais",
            en: "International Transport"
        },
        SERVICE_ORCAMENTO: {
            pt: "Orçamento á medida",
            en: "Custom Quote"
        },
        HOURS: {
            pt: "24 Horas | Segunda a Domingo",
            en: "24 Hours | Monday to Sunday"
        }
    },

    // Contact Page
    CONTACT: {
        TITLE: {
            pt: "CONTACTE-NOS",
            en: "CONTACT US"
        },
        SUBTITLE: {
            pt: "Contactos",
            en: "Contacts"
        },
        FORM_TITLE: {
            pt: "Peça já o seu orçamento gratuito",
            en: "Request your free quote now"
        },
        PHONE_TITLE: {
            pt: "Telefone",
            en: "Phone"
        },
        PHONE_DESC: {
            pt: "Estamos disponíveis 24 horas por dia, 7 dias por semana.",
            en: "We are available 24 hours a day, 7 days a week."
        },
        EMAIL_TITLE: {
            pt: "Email",
            en: "Email"
        },
        EMAIL_DESC: {
            pt: "A nossa equipa responderá o mais breve possível.",
            en: "Our team will respond as soon as possible."
        },
        ADDRESS_TITLE: {
            pt: "Morada",
            en: "Address"
        },
        LOCATION_TITLE: {
            pt: "Localização",
            en: "Location"
        },
        LOCATION_SUBTITLE: {
            pt: "Onde estamos",
            en: "Where we are"
        }
    },

    // About Us Page
    ABOUT: {
        TITLE: {
            pt: "SOBRE NÓS",
            en: "ABOUT US"
        },
        SUBTITLE: {
            pt: "Conheça a nossa empresa",
            en: "Get to know our company"
        }
    },

    // Tips Page
    TIPS: {
        TITLE: {
            pt: "DICAS ÚTEIS",
            en: "USEFUL TIPS"
        },
        SUBTITLE: {
            pt: "Prepare a sua mudança com as nossas recomendações",
            en: "Prepare your move with our recommendations"
        }
    },

    // Services Page
    SERVICES_PAGE: {
        TITLE: {
            pt: "OS NOSSOS SERVIÇOS",
            en: "OUR SERVICES"
        },
        SUBTITLE: {
            pt: "Soluções profissionais para mudanças residenciais e empresariais.",
            en: "Professional solutions for residential and business moves."
        },
        SECTION_TITLE: {
            pt: "O que fazemos",
            en: "What we do"
        },
        SECTION_SUBTITLE: {
            pt: "Serviços",
            en: "Services"
        }
    },

    // About Four Component
    ABOUT_FOUR: {
        SUBTITLE: {
            pt: "Quem somos",
            en: "Who we are"
        },
        TITLE: {
            pt: "Transportes e Mudanças Profissionais",
            en: "Professional Transport and Moving"
        },
        PARAGRAPH_1: {
            pt: "A FielCarga Unipessoal Lda., surge no âmbito de criar uma oferta de prestação de serviço de transporte de mercadorias quer no mercado residencial, como empresarial.",
            en: "FielCarga Unipessoal Lda. was created to offer freight transport services in both residential and business markets."
        },
        PARAGRAPH_2: {
            pt: "A nossa aposta passa por desenvolver uma forte relação com os nossos clientes, permitindo assim conhecer as suas necessidades reais de forma a desenhar soluções à sua medida.",
            en: "Our focus is on developing a strong relationship with our clients, allowing us to understand their real needs and design tailored solutions."
        },
        BUTTON: {
            pt: "Contacte-nos",
            en: "Contact Us"
        }
    },

    // 404 Page
    ERROR_404: {
        TITLE: {
            pt: "Página não encontrada",
            en: "Page not found"
        },
        DESCRIPTION: {
            pt: "Lamentamos, mas a página que procura não existe ou foi movida.",
            en: "Sorry, the page you are looking for does not exist or has been moved."
        },
        BUTTON: {
            pt: "Voltar ao Início",
            en: "Go Back"
        }
    },

    // Common texts
    COMMON: {
        COMPANY_NAME: {
            pt: "FielCarga Transportes & Mudanças",
            en: "FielCarga Transport & Moving"
        },
        ADDRESS: {
            pt: "Rua Dom Afonso Henriques, 1539",
            en: "Rua Dom Afonso Henriques, 1539"
        },
        POSTAL_CODE: {
            pt: "4425-636 Pedrouços - Maia",
            en: "4425-636 Pedrouços - Maia"
        },
        SEE_MORE: {
            pt: "Ver mais",
            en: "See more"
        },
        READ_LESS: {
            pt: "Ler menos",
            en: "Read less"
        },
        CLOSE: {
            pt: "Fechar",
            en: "Close"
        },
        CONTACTS_LABEL: {
            pt: "CONTACTOS",
            en: "CONTACTS"
        },
        DELIVERY: {
            pt: "ENTREGA",
            en: "DELIVERY"
        },
        HELLO: {
            pt: "Olá!",
            en: "Hello!"
        },
        HI: {
            pt: "Oi!",
            en: "Hi!"
        }
    },

    // Privacy Policy
    PRIVACY_POLICY_PAGE: {
        TITLE: {
            pt: "Política de Privacidade",
            en: "Privacy Policy"
        },
        BREADCRUMB_TITLE: {
            pt: "POLÍTICA DE PRIVACIDADE",
            en: "PRIVACY POLICY"
        },
        SECTION_TITLE: {
            pt: "Política de Privacidade da FieltransCarga Unipessoal Lda.",
            en: "Privacy Policy of FieltransCarga Unipessoal Lda."
        },
        INTRO: {
            pt: "A FieltransCarga Unipessoal Lda. tem um compromisso permanente com o respeito pela privacidade de todos os seus clientes, utilizadores e visitantes. A nossa prioridade é sermos transparentes sobre a forma como tratamos os dados pessoais que nos são fornecidos. A nossa Política de Privacidade visa explicar como recolhemos, utilizamos e protegemos os dados pessoais que nos envia através do nosso website, por email, telefone, ou através dos nossos parceiros de serviços.",
            en: "FieltransCarga Unipessoal Lda. has a permanent commitment to respect the privacy of all its customers, users and visitors. Our priority is to be transparent about how we handle the personal data you provide to us. Our Privacy Policy aims to explain how we collect, use and protect the personal data you send us through our website, email, telephone, or through our service partners."
        },
        DATA_COLLECTION_TITLE: {
            pt: "Recolha e Tratamento de Dados Pessoais",
            en: "Collection and Processing of Personal Data"
        },
        DATA_COLLECTION_TEXT: {
            pt: "A FieltransCarga Unipessoal Lda. recolhe os dados pessoais necessários para o fornecimento dos nossos serviços, incluindo, mas não se limitando a, nome, email, número de telefone, morada, e número de identificação fiscal. Esses dados são tratados de acordo com o Regulamento (UE) 2016/679, relativo à proteção das pessoas singulares no que diz respeito ao tratamento de dados pessoais.",
            en: "FieltransCarga Unipessoal Lda. collects the personal data necessary for the provision of our services, including, but not limited to, name, email, telephone number, address, and tax identification number. This data is processed in accordance with Regulation (EU) 2016/679 on the protection of individuals with regard to the processing of personal data."
        },
        ADVERTISING_TITLE: {
            pt: "Publicidade e Cookies",
            en: "Advertising and Cookies"
        },
        ADVERTISING_TEXT_1: {
            pt: "A FieltransCarga Unipessoal Lda. utiliza ferramentas de publicidade, como o Google Ads, para promover os seus serviços. Ao interagir com os nossos anúncios, informações sobre a sua navegação no nosso site podem ser recolhidas, incluindo dados sobre cliques e visitas. Estes dados são usados para melhorar a relevância dos anúncios e a experiência do utilizador.",
            en: "FieltransCarga Unipessoal Lda. uses advertising tools, such as Google Ads, to promote its services. When you interact with our ads, information about your browsing on our site may be collected, including data about clicks and visits. This data is used to improve the relevance of ads and the user experience."
        },
        ADVERTISING_TEXT_2: {
            pt: "Caso deseje, pode desativar os cookies de publicidade nas configurações do seu navegador. Isso pode afetar a forma como os anúncios são exibidos para si. Para mais informações sobre o uso de cookies e como controlá-los, consulte a nossa Política de Cookies.",
            en: "If you wish, you can disable advertising cookies in your browser settings. This may affect how ads are displayed to you. For more information on the use of cookies and how to control them, please see our Cookie Policy."
        },
        RIGHTS_TITLE: {
            pt: "Direitos dos Utilizadores",
            en: "User Rights"
        },
        RIGHTS_INTRO: {
            pt: "De acordo com a legislação aplicável, a FieltransCarga Unipessoal Lda. compromete-se a respeitar a confidencialidade dos seus dados pessoais e garantir o exercício dos seus direitos. Estes direitos incluem:",
            en: "In accordance with applicable legislation, FieltransCarga Unipessoal Lda. is committed to respecting the confidentiality of your personal data and ensuring the exercise of your rights. These rights include:"
        },
        RIGHT_INFORMED: {
            pt: "Direito a ser informado:",
            en: "Right to be informed:"
        },
        RIGHT_INFORMED_TEXT: {
            pt: "Tem direito a obter informações claras sobre como utilizamos os seus dados pessoais.",
            en: "You have the right to obtain clear information about how we use your personal data."
        },
        RIGHT_ACCESS: {
            pt: "Direito de acesso:",
            en: "Right of access:"
        },
        RIGHT_ACCESS_TEXT: {
            pt: "Pode aceder aos dados pessoais que tratamos e conservarmos, bem como solicitar uma cópia dos mesmos.",
            en: "You can access the personal data we process and retain, as well as request a copy of it."
        },
        RIGHT_RECTIFICATION: {
            pt: "Direito de retificação:",
            en: "Right of rectification:"
        },
        RIGHT_RECTIFICATION_TEXT: {
            pt: "Pode corrigir ou atualizar os seus dados pessoais, caso estejam incorretos ou desatualizados.",
            en: "You can correct or update your personal data if it is incorrect or out of date."
        },
        RIGHT_ERASURE: {
            pt: "Direito de apagamento:",
            en: "Right to erasure:"
        },
        RIGHT_ERASURE_TEXT: {
            pt: "Pode solicitar a eliminação dos seus dados pessoais.",
            en: "You can request the deletion of your personal data."
        },
        RIGHT_OBJECTION: {
            pt: "Direito de oposição:",
            en: "Right to object:"
        },
        RIGHT_OBJECTION_TEXT: {
            pt: "Pode, a qualquer momento, remover-se de campanhas de comunicação ou publicidade.",
            en: "You can, at any time, remove yourself from communication or advertising campaigns."
        },
        RIGHT_PORTABILITY: {
            pt: "Direito à portabilidade:",
            en: "Right to data portability:"
        },
        RIGHT_PORTABILITY_TEXT: {
            pt: "Pode solicitar a transferência dos seus dados pessoais para outro responsável pelo tratamento.",
            en: "You can request the transfer of your personal data to another data controller."
        },
        RIGHT_RESTRICTION: {
            pt: "Direito à limitação do tratamento:",
            en: "Right to restriction of processing:"
        },
        RIGHT_RESTRICTION_TEXT: {
            pt: "Pode solicitar que restrinjamos o tratamento dos seus dados, em determinadas circunstâncias.",
            en: "You can request that we restrict the processing of your data in certain circumstances."
        },
        CONTACT_TEXT: {
            pt: "Para exercer qualquer um dos direitos acima, pode entrar em contacto connosco através do email",
            en: "To exercise any of the above rights, you can contact us via email"
        },
        CONTACT_OR_PHONE: {
            pt: "ou pelo telefone",
            en: "or by phone"
        },
        CHANGES_TITLE: {
            pt: "Alterações à Política de Privacidade",
            en: "Changes to Privacy Policy"
        },
        CHANGES_TEXT: {
            pt: "A FieltransCarga Unipessoal Lda. reserva-se o direito de alterar esta Política de Privacidade sempre que necessário, por motivos legais, de segurança ou para a adaptação a novas exigências regulamentares. Recomendamos que consulte esta política periodicamente para se manter atualizado.",
            en: "FieltransCarga Unipessoal Lda. reserves the right to change this Privacy Policy whenever necessary, for legal, security or adaptation to new regulatory requirements. We recommend that you consult this policy periodically to stay updated."
        },
        ACCEPTANCE_TITLE: {
            pt: "Aceitação da Política de Privacidade",
            en: "Acceptance of Privacy Policy"
        },
        ACCEPTANCE_TEXT: {
            pt: "Ao utilizar o nosso website, fornece o seu consentimento para o tratamento dos seus dados pessoais de acordo com os termos descritos nesta Política de Privacidade. Se não concordar com algum dos pontos aqui mencionados, por favor, não utilize os nossos serviços.",
            en: "By using our website, you provide your consent to the processing of your personal data in accordance with the terms described in this Privacy Policy. If you do not agree with any of the points mentioned here, please do not use our services."
        },
        LAST_UPDATE: {
            pt: "Última atualização da Política de Privacidade: 1 de Janeiro de 2025.",
            en: "Last update to Privacy Policy: January 1, 2025."
        }
    },

    // Terms of Use
    TERMS_PAGE: {
        TITLE: {
            pt: "Termos e Condições",
            en: "Terms and Conditions"
        },
        BREADCRUMB_TITLE: {
            pt: "TERMOS E CONDIÇÕES",
            en: "TERMS AND CONDITIONS"
        },
        SECTION_TITLE: {
            pt: "O nosso compromisso é CONSIGO!",
            en: "Our commitment is with YOU!"
        },
        INTRO: {
            pt: "A www.fielcarga.com é um domínio com website associado e registado pela FieltransCarga Unip., Lda. com o contribuinte número 515882623 e com o Alvará nº 669921, para promover a prestação de serviços de transporte de mercadorias e mudanças a nível nacional (incluindo ilhas) e internacional, atuando também como agente intermediário de outros fornecedores de transporte de mercadorias e logística, no entanto, não aceita nenhuma responsabilidade pelos atos ou omissões do fornecedor pelos serviços prestados por eles. O presente documento regula os termos e condições gerais que se estabelece entre a FieltransCarga Unip., Lda. e o cliente, utilizador ou visitante.",
            en: "www.fielcarga.com is a domain with an associated website registered by FieltransCarga Unip., Lda. with tax number 515882623 and License No. 669921, to promote the provision of freight and moving services at national (including islands) and international level, also acting as an intermediary agent for other freight and logistics providers, however, it does not accept any responsibility for the acts or omissions of the provider for the services provided by them. This document regulates the general terms and conditions established between FieltransCarga Unip., Lda. and the customer, user or visitor."
        },
        INTRO_2: {
            pt: "Aconselhamos a uma leitura regular dos nossos termos e condições de forma a estar de acordo com a última atualização.",
            en: "We advise you to read our terms and conditions regularly to be in accordance with the latest update."
        },
        SUBSCRIPTION_TITLE: {
            pt: "1. Subscrição dos nossos serviços.",
            en: "1. Subscription to our services."
        },
        SUBSCRIPTION_TEXT: {
            pt: "Os nossos serviços não são destinados a menores. Se tem menos de 18 anos de idade não deve subscrever os nossos serviços. A FieltransCarga Unip., Lda. reserva-se no direito de recusar a prestação de serviços, sem necessidade de justificar a razão de tal decisão.",
            en: "Our services are not intended for minors. If you are under 18 years of age you should not subscribe to our services. FieltransCarga Unip., Lda. reserves the right to refuse the provision of services, without the need to justify the reason for such a decision."
        },
        RESPONSIBILITIES_TITLE: {
            pt: "2. Responsabilidades",
            en: "2. Responsibilities"
        },
        RESPONSIBILITIES_TEXT: {
            pt: "A FieltransCarga Unip., Lda. não é responsável por prejuízos decorrentes durante o transporte das mercadorias, exceto em situações especificas e acordadas. A FieltransCarga Unip., Lda. não pode ser responsabilizada por danos ou prejuízos na mercadoria, resultantes de embalamento defeituoso, insuficiente ou a falta do mesmo, por parte do cliente. As mercadorias com necessidade de ligação elétrica como por exemplo, televisores, é verificado o seu funcionamento antes do seu embalamento no local de carga e no local de descarga com a presença do cliente de forma a garantir o estado da mercadoria. Todas as mercadorias de valor, como por exemplo, joias, moedas, notas de coleção, relógios, dinheiro, entre outros valores, devem ser transportados pelo cliente. Em caso da FieltransCarga Unip., Lda. transportar essas mercadorias por pedido do cliente, estas devem ser transportadas em embalagem selada. A Fieltranscarga Unip., Lda. não faz o transporte de mercadorias cujo conteúdo seja ilegal, ou que possa por em risco a segurança dos colaboradores ou outras pessoas durante todo o serviço a prestar. É da responsabilidade do cliente, garantir que as mercadorias com conteúdos embalados pelo cliente, são totalmente legais e passiveis de transporte legal. Não deve utilizar os nossos serviços para qualquer fim ilegal ou não autorizado que viole as leis e regulamentação. O nosso horário funcionamento está compreendido na hora local de Portugal Continental entre as 09h.00m e as 23h.00m de segunda a sábado, domingos e feriados o horário é mediante o serviço a realizar e acordado antecipadamente.",
            en: "FieltransCarga Unip., Lda. is not responsible for damages arising during the transport of goods, except in specific and agreed situations. FieltransCarga Unip., Lda. cannot be held responsible for damage or loss to goods resulting from defective, insufficient or lack of packaging by the customer. Goods requiring electrical connection, such as televisions, are checked for functionality before packaging at the loading location and at the unloading location in the presence of the customer to ensure the condition of the goods. All valuables, such as jewelry, coins, collectible notes, watches, money, among other valuables, must be transported by the customer. If FieltransCarga Unip., Lda. transports these goods at the customer's request, they must be transported in sealed packaging. Fieltranscarga Unip., Lda. does not transport goods whose content is illegal, or that may endanger the safety of employees or other people during the entire service to be provided. It is the customer's responsibility to ensure that goods with contents packed by the customer are completely legal and subject to legal transport. You must not use our services for any illegal or unauthorized purpose that violates laws and regulations. Our operating hours are between 9:00 am and 11:00 pm local time in mainland Portugal from Monday to Saturday, Sundays and holidays the hours are according to the service to be performed and agreed in advance."
        },
        PAYMENT_TITLE: {
            pt: "3. Pagamento e Faturação",
            en: "3. Payment and Billing"
        },
        PAYMENT_TEXT: {
            pt: "A Fieltranscarga Unip., Lda. reserva-se ao direito de, em qualquer momento, proceder à alteração da tabela de preços dos serviços comercializados. Os pagamentos deverão ser efetuados mediante proposta apresentada e no final de cada serviço. Após pagamento, é enviada a fatura/recibo emitido e enviado por email facultado pelo cliente. Se o pagamento não for efetuado, a Fieltranscarga reserva o direito de suspender ou cancelar os serviços, não podendo a Fieltranscarga ser responsabilizada por perdas ou prejuízos daí resultantes. Todos os serviços por nós prestados são passíveis de faturação. Após a liquidação da fatura enviada ao cliente, a Fieltranscarga Unip., Lda. disponibiliza ao cliente, em formato eletrónico o respetivo recibo. O cliente é responsável por fornecer todos os dados atualizados para faturação.",
            en: "Fieltranscarga Unip., Lda. reserves the right, at any time, to change the price list of services sold. Payments must be made according to the proposal presented and at the end of each service. After payment, the invoice/receipt is issued and sent by email provided by the customer. If payment is not made, Fieltranscarga reserves the right to suspend or cancel the services, and Fieltranscarga cannot be held responsible for losses or damages resulting from this. All services provided by us are subject to invoicing. After settlement of the invoice sent to the customer, Fieltranscarga Unip., Lda. provides the customer with the respective receipt in electronic format. The customer is responsible for providing all updated data for invoicing."
        },
        SUSPENSION_TITLE: {
            pt: "4. Suspensão ou Cancelamento do Serviço",
            en: "4. Suspension or Cancellation of Service"
        },
        SUSPENSION_TEXT: {
            pt: "A Fieltranscarga Unip., Lda. reserva-se no direito de suspender e/ou cancelar os serviços a prestar, caso as mercadorias não estejam conforme a informação prestada pelo cliente no momento da adjudicação. Se o cancelamento for devido a violação por parte do cliente de alguma das condições do serviço descritas neste documento, será efetuado a cobrança dos valores gastos na preparação da prestação do serviço contratado.",
            en: "Fieltranscarga Unip., Lda. reserves the right to suspend and/or cancel the services to be provided if the goods are not in accordance with the information provided by the customer at the time of award. If the cancellation is due to a violation by the customer of any of the service conditions described in this document, the amounts spent in preparing the provision of the contracted service will be charged."
        },
        DISPUTES_TITLE: {
            pt: "5. Litígios",
            en: "5. Disputes"
        },
        DISPUTES_TEXT_1: {
            pt: "Só serão consideradas as reclamações que tiverem sido apresentadas por escrito pelo reclamante à Fieltranscarga Unip., Lda. no prazo máximo de 15 dias após o serviço contratado tiver finalizado.",
            en: "Only complaints that have been submitted in writing by the complainant to Fieltranscarga Unip., Lda. within a maximum period of 15 days after the contracted service has been completed will be considered."
        },
        DISPUTES_TEXT_2: {
            pt: "Quaisquer litígios serão resolvidos no Tribunal da Comarca do Porto, Portugal, com exclusão expressa de qualquer outro.",
            en: "Any disputes will be resolved in the Court of the District of Porto, Portugal, with express exclusion of any other."
        },
        DISPUTES_TEXT_3: {
            pt: "Em caso de litígio o consumidor pode recorrer a uma Entidade de Resolução Alternativa de Litígios de consumo: Centro de Arbitragem de Conflitos de Consumo - Porto R. de Damião de Góis 31 loja 6, 4050-225 Porto, Telefone 22 550 8349 Mais informações em Portal do Consumidor",
            en: "In case of dispute, the consumer can resort to an Alternative Consumer Dispute Resolution Entity: Consumer Dispute Arbitration Center - Porto R. de Damião de Góis 31 shop 6, 4050-225 Porto, Telephone 22 550 8349 More information at Consumer Portal"
        },
        MORE_INFO_TITLE: {
            pt: "Mais Informações",
            en: "More Information"
        },
        MORE_INFO_TEXT: {
            pt: "Para mais informação das condições de utilização dos nossos serviços, por favor envie-nos um e-mail para:",
            en: "For more information on the conditions of use of our services, please send us an email to:"
        },
        LAST_UPDATE: {
            pt: "Última atualização dos Termos e Condições: 1 de Janeiro de 2025.",
            en: "Last update to Terms and Conditions: January 1, 2025."
        }
    },

    // Cookie Consent
    COOKIE_CONSENT: {
        TITLE: {
            pt: "Utilizamos Cookies",
            en: "We Use Cookies"
        },
        MESSAGE: {
            pt: "Este website utiliza cookies para melhorar a sua experiência de navegação e fornecer funcionalidades personalizadas. Ao continuar a navegar, concorda com a nossa utilização de cookies.",
            en: "This website uses cookies to improve your browsing experience and provide personalized features. By continuing to browse, you agree to our use of cookies."
        },
        ACCEPT: {
            pt: "Aceitar",
            en: "Accept"
        },
        DECLINE: {
            pt: "Recusar",
            en: "Decline"
        },
        LEARN_MORE: {
            pt: "Saber mais",
            en: "Learn more"
        }
    },

    // WhatsApp Button
    WHATSAPP: {
        TOOLTIP: {
            pt: "Fale Connosco no WhatsApp!",
            en: "Chat with us on WhatsApp!"
        },
        ARIA_LABEL: {
            pt: "Contactar via WhatsApp",
            en: "Contact via WhatsApp"
        }
    },

    // Registration Number Info
    REGISTRATION: {
        TITLE: {
            pt: "Chamada para a rede móvel nacional",
            en: "Call to the national mobile network"
        },
        NUMBER: {
            pt: "Chamada para a rede móvel nacional",
            en: "Call to the national mobile network"
        },
        TOOLTIP: {
            pt: "Chamada para a rede móvel nacional",
            en: "Call to the national mobile network"
        }
    }
};


